import { DiscountGroupType } from "@redotech/redo-model/discount";
import * as z from "zod/v4";
import { redoDiscountSchema } from "./discount-schemas";

export const getDiscountsByTeam = {
  name: "getDiscountsByTeam" as const,
  input: z.object({ groupType: z.enum(DiscountGroupType).optional() }),
  output: z.array(redoDiscountSchema),
};
